// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  senderId: __t.u64().name("sender_id"),
  receiverId: __t.u64().name("receiver_id"),
  giftType: __t.string().name("gift_type"),
  amount: __t.i64(),
  itemId: __t.option(__t.u64()).name("item_id"),
  createdAt: __t.u64().name("created_at"),
});
